<template>
  <div class='EnbLogo01'>
    <img :src="Logo" @click="push">
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'EnbLogo01',
  computed: {
    ...mapGetters(['Logo', 'Empresa'])
  },
  methods: {
    ...mapActions(['changeFilterProdStore', 'GetStoreProducts', 'Loading']),
    async push () {
      this.Loading(true)
      if(this.Empresa.modelo === 'Modelo 03') {
        this.$router.push(`/site`)  
      }
      else {
        this.$router.push(`/loja`)
      }
      this.GetStoreProducts({ params: { last: [], limit: 8, categoria: '' }, init: true })
        .then(() => this.Loading(false))
    }
  }
}
</script>

<style scoped>
.EnbLogo01 {
  display: flex;
  justify-content: start;
  align-items: center;
  width: 280px;
  height: 100px;
  cursor: pointer;
}

img {
  width: 280px;
  height: 100px;
}

@media screen and (max-width: 500px) {
  .EnbLogo01 {
    width: 75%;
    display: flex;
    justify-content: center;
  }
}
</style>
